export default "__VITE_ASSET__DfqnbG4J__"